import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAajeevikaMemberRedisPayload } from '../components/models/dashboard.model';
import { IMemberDetail } from '../interfaces/member.interface';
import { IGetAajeevikaMemberRedisRes } from '../interfaces/response.interface';
import { CacheService } from './cache.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private baseUrl = environment.apiBaseUrl;
    dataSource: IMemberDetail[] = [];
    xTag:string|null = null;

    constructor(private http: HttpClient, private cacheService: CacheService) { }

    getAajeevikaMembersRedis(payload: IAajeevikaMemberRedisPayload): Observable<IGetAajeevikaMemberRedisRes> {
      const params: any = { ...payload };

      return this.http.get<IGetAajeevikaMemberRedisRes>(`${this.baseUrl}member`, { params });
    }
    getAajeevikaMembersRedisV2(payload: IAajeevikaMemberRedisPayload, forceRefresh = false, enableCaching = true, cacheTime = '300', apiKey = this.cacheService.API_KEYS.MEMBERS_LISTING ): Observable<any> {
      const params: any = { ...payload };
      let headers = {};

      if (enableCaching) {
        this.xTag = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        headers = { 'Cache-Control': `private, max-age=${cacheTime}`, 'x-tag': this.xTag };

        if (forceRefresh) {
          params['ts'] = Date.now();
        } else {
          const ts = this.cacheService.getTimestamp(apiKey);
          if(ts) {
            params['ts'] = ts;
          }
        }
      }

      return this.http.get<IGetAajeevikaMemberRedisRes>(`${this.baseUrl}member`, { headers, params, observe:'response' }).pipe(
        tap((response) => {
          if (enableCaching) {
            const xTag = response.headers.get('x-tag');
            if(forceRefresh){
              this.cacheService.setTimestamp(apiKey, params['ts']);

            }
            if(forceRefresh || xTag === this.xTag){
                if (this.cacheService.hasDirtyIds(apiKey)) {
                this.cacheService.clearDirtyIds(apiKey);
              }
            }

          }
        })
      );
    }
    getDashboardCountData(payload: any, enableCaching = true, cacheTime = '300', apiKey = this.cacheService.API_KEYS.DASHBOARD_COUNT ): Observable<any> {
      const params: any = { ...payload };
      let headers = {};

      if (enableCaching) {
        headers = { 'Cache-Control': `private, max-age=${cacheTime}`};


          const ts = this.cacheService.getTimestamp(apiKey);
          if(ts) {
            params['ts'] = ts;
          }
      }

      return this.http.get(`${this.baseUrl}member/dashboard-crp`, { headers, params });
    }
}
